import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectSmartDeviceCurrentStepIndex,
  selectSmartDeviceCurrentSubstepIndex,
  selectSmartDeviceFlowType,
  setSmartDeviceCurrentStepIndex,
  setSmartDeviceCurrentSubstepIndex,
  setSmartDeviceFlowType
} from '../redux/features/smartDeviceFlowSlice';
import { smart_device_insurance_flow } from '../pages/smartDeviceInsurancePages/newSmartDevicePolicy/data';

const useSmartDeviceFlow = () => {
    const dispatch = useDispatch();
    const flowType = useSelector(selectSmartDeviceFlowType);
    const currentStepIndex = useSelector((state) => selectSmartDeviceCurrentStepIndex(state));
    const currentSubstepIndex = useSelector((state) => selectSmartDeviceCurrentSubstepIndex(state));

    const steps = smart_device_insurance_flow[flowType] || smart_device_insurance_flow.default || [];
    const currentStep = steps[currentStepIndex] || {};
    const currentSubstep = currentStep.substeps ? currentStep.substeps[currentSubstepIndex] : '';

    const handleFlowChange = (type, currentStepIndex, currentSubstepIndex) => {
        dispatch(setSmartDeviceFlowType({ type, currentStepIndex, currentSubstepIndex }));
    };

    const handleNextSubstep = () => {
        if (currentStep.substeps && currentSubstepIndex < currentStep.substeps.length - 1) {
            dispatch(setSmartDeviceCurrentSubstepIndex(currentSubstepIndex + 1));
        }
        else if (currentSubstepIndex === currentStep.substeps.length - 1) {
            handleNextStep();
        }
    };

    const handlePrevSubstep = () => {
        if (currentSubstepIndex > 0) {
            dispatch(setSmartDeviceCurrentSubstepIndex(currentSubstepIndex - 1));
        }
        else {
            handlePrevStep();
        }
    };

    const handleNextStep = () => {
        if (currentStepIndex < steps.length - 1) {
            dispatch(setSmartDeviceCurrentStepIndex(currentStepIndex + 1));
            dispatch(setSmartDeviceCurrentSubstepIndex(0));
        }
    };

    const handlePrevStep = () => {
        if (currentStepIndex > 0) {
            const prevStep = steps[currentStepIndex - 1] || {};
            const substepIndex = prevStep?.substeps?.length - 1 || 0;
            dispatch(setSmartDeviceCurrentStepIndex(currentStepIndex - 1));
            dispatch(setSmartDeviceCurrentSubstepIndex(substepIndex));
        }
    };

    return {
        handleFlowChange,
        handleNextSubstep,
        handlePrevSubstep,
        handleNextStep,
        handlePrevStep,
        flowType,
        steps,
        currentStep,
        currentStepIndex,
        currentSubstep,
        currentSubstepIndex,
    };
};

export default useSmartDeviceFlow;
